import {  Typography, ToggleButton, Slider, type SliderProps} from '@tunasong/ui-lib'
import { symbols } from '@tunasong/music-lib'
import React, { useCallback, useId } from 'react'
import type { FC, MouseEventHandler } from 'react'
import styles from './transpose.module.css'

export interface TransposeProps extends Omit<SliderProps, 'onChange'> {
  value?: number
  onChange(event: unknown, semiTones: number): void
}

export const Transpose: FC<TransposeProps> = ({ value = 0, onChange, ...restProps }) => {
  const headingId = useId()
  const handleChange = useCallback(
    (event: Event, value: number | number[]) => onChange(event, value as number),
    [onChange]
  )
  const handleClick = useCallback(
    (semiTones: number): MouseEventHandler<HTMLElement> =>
      (ev: React.SyntheticEvent) =>
        onChange(ev, semiTones),
    [onChange]
  )
  return (
    <div className={styles.container}>
      <Typography id={headingId} variant="subtitle1" display={'block'} className={styles.subtitle}>
        Transpose
      </Typography>
      <div className={styles.tuningRow}>
        {/* @see http://www.musikkteori.net/2011/05/23/laer-hvordan-du-transponerer-musikk-til-ulike-instrumenter/ */}
        <ToggleButton selected={value === 0} value="C" onClick={handleClick(0)}>
          C tuning
        </ToggleButton>
        <ToggleButton selected={value === 2} value="Bb" onClick={handleClick(2)}>
          B{symbols.FLAT} tuning
        </ToggleButton>
        <ToggleButton selected={value === 9} value="Eb" onClick={handleClick(9)}>
          E{symbols.FLAT} tuning
        </ToggleButton>
        <ToggleButton selected={value === 7} value="F" onClick={handleClick(7)}>
          F tuning
        </ToggleButton>
      </div>
      <div className={styles.sliderBox}>
        {/* Need the box container because marks overflows */}
        <Slider
          aria-labelledby={headingId}
          {...restProps}
          step={1}
          min={-11}
          max={11}
          value={value}
          onChange={handleChange}
          valueLabelDisplay="on"
          valueLabelFormat={v => (v > 0 ? `+${v}` : String(v))}
        />
      </div>
    </div>
  )
}
